const stripTrailingSlash = (url) => url.replace(/\/+$/, '');
const normalizeText = (value) => (value == null ? '' : String(value).trim());

const PUBLIC_SITE_URL_BY_BRANCH = {
  staging: 'https://staging.coachimhungry.com',
  main: 'https://coachimhungry.com',
  master: 'https://coachimhungry.com',
  production: 'https://coachimhungry.com',
};

export const getDeployBranch = () => normalizeText(
  import.meta.env.VITE_DEPLOY_BRANCH ||
  import.meta.env.VITE_BRANCH ||
  import.meta.env.VITE_GIT_BRANCH ||
  import.meta.env.VITE_NETLIFY_BRANCH ||
  import.meta.env.VITE_VERCEL_GIT_COMMIT_REF ||
  import.meta.env.VITE_RAILWAY_GIT_BRANCH
).toLowerCase();

/**
 * Determine the public site URL that should be used in externally shared links.
 * Priority:
 *   1. Explicit VITE_PUBLIC_SITE_URL env override
 *   2. Build/deploy branch mapping injected by Vite
 *   3. Current window.location.origin when available (browser runtime)
 *   4. Production domain fallback
 */
export const getPublicSiteUrl = () => {
  const envUrl = normalizeText(import.meta.env.VITE_PUBLIC_SITE_URL);
  if (envUrl) {
    return stripTrailingSlash(envUrl);
  }

  const branchUrl = PUBLIC_SITE_URL_BY_BRANCH[getDeployBranch()];
  if (branchUrl) {
    return branchUrl;
  }

  if (typeof window !== 'undefined' && window?.location?.origin) {
    return stripTrailingSlash(window.location.origin);
  }

  // Default to the production domain if we cannot infer anything else.
  return 'https://coachimhungry.com';
};

/**
 * Build a fully qualified URL by appending an optional path to the public site URL.
 */
export const buildAppUrl = (path = '') => {
  const base = getPublicSiteUrl();
  if (!path) return base;
  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
};
